import React, { useEffect, useState } from "react";

import Modal from "react-bootstrap/Modal";
import Badge from "react-bootstrap/Badge";
import ListGroup from "react-bootstrap/ListGroup";
import { AiFillCloseCircle } from "react-icons/ai";

import Box from "./Box";
import Item from "./Item";
import MainBtn from "../mainBtn/MainBtn";

import "./ItemList.css";

const ItemList = ({
  withPrice,
  boxes,
  onChange,
  handleProducts,
  cart,
  products,
  categories,
  showProductsImmediately,
  isServices,
}) => {
  const [modal, setModal] = useState(null);
  const [modalArr, setModalArr] = useState(products); // eslint-disable-line
  // const [cart, setCart] = useState([]);

  // useEffect(() => {
  //   setCart(values)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  const handleClose = (e) => {
    if (e) e.preventDefault();
    setModal(null);
  };

  const handleShow = (el) => {
    setModal(el.title);
    setModalArr(el.products);
  };

  const handleAdd = (el) => {
    const index = cart.findIndex((obj) => obj.title === el.title);
    let newCart = [];

    if (index === -1) {
      if (el.number > 0) {
        newCart = [...cart, el];
      }
    } else {
      if (el.number === 0) {
        newCart = [...cart.slice(0, index), ...cart.slice(index + 1)];
      } else {
        newCart = [...cart.slice(0, index), el, ...cart.slice(index + 1)];
      }
    }
    // setCart(newCart);
    handleProducts(newCart);
  };
  const removeItem = (el) => {
    const index = cart.findIndex((obj) => obj.entityId === el.entityId);
    let newCart = [...cart.slice(0, index), ...cart.slice(index + 1)];
    // setCart(newCart);
    handleProducts(newCart);
  };
  return (
    <>
      <div className="ItemsList">
        <Box items={boxes} onChange={onChange} />
        {!showProductsImmediately ? (
          categories.map((category, i) => {
            return (
              <div
                className="item"
                key={`category_item_${i}`}
                onClick={() => handleShow(category)}
              >
                <img src={category.image} alt="" />
                <div className="itemText">
                  <strong className="itemH">{category.title}</strong>
                  {withPrice ? (
                    <p className="itemPrice"> ₪ {category.price}</p>
                  ) : null}
                </div>
              </div>
            );
          })
        ) : (
          <div className="productsList">
            {products.map((el, i) => {
              return (
                <>
                  <Item
                    values={cart}
                    product={el}
                    entityId={el.entityId}
                    img={el.image}
                    title={el.title}
                    key={`product_item_${i}`}
                    handleAdd={handleAdd}
                    handleRemove={removeItem}
                  />
                </>
              );
            })}
          </div>
        )}
        <div className="myItems">
          <h5>הפריטים שלי</h5>
          <ListGroup>
            {cart
              ? cart.filter(i => i.entityId !== 277629 && i.entityId !== 277538).map((item, key) => (
                <ListGroup.Item
                  className="d-flex justify-content-between"
                  id={`cart_item_${key}`}
                  key={`cart_key_item_${key}`}
                >
                  <div className="titleNum">
                    <h6>{item.title}</h6>{item.number ? 'x' : ''}<p>{item.number}</p>
                  </div>
                  <div className="badges">
                    <div className="badgesWithoutIcon">
                      {item.p ? (
                        <Badge bg="warning" pill>
                          פירוק
                        </Badge>
                      ) : null}
                      {item.h ? (
                        <Badge bg="warning" pill>
                          הרכבה
                        </Badge>
                      ) : null}
                    </div>
                    <AiFillCloseCircle onClick={() => removeItem(item)} />
                  </div>
                </ListGroup.Item>
              ))
              : null}
          </ListGroup>
          {/* <h5 className="cubAmount">
            כמות שטח נדרשת: <strong>2 קוב</strong>
          </h5> */}
        </div>
      </div>

      <Modal show={Boolean(modal)} onHide={handleClose} className="modal">
        <h1>{modal}</h1>
        <div className="productsList">
          {modalArr.map((el, i) => (
            <Item
              product={el}
              id={el.id}
              img={el.image}
              title={el.title}
              key={`modal_product_item_${i}`}
              handleAdd={handleAdd}
              handleRemove={removeItem}
              values={cart}
              havePeruk={el.attributeValues.disassemblePrice ? true : false}
              haveHarkava={el.attributeValues.assemblePrice ? true : false}
              isServices={isServices}
            />
          ))}
        </div>
        <div className="modalBtn">
          <MainBtn button text="אישור" onClick={handleClose} />
        </div>
      </Modal>
    </>
  );
};

export default ItemList;
